module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form__group",
    class: {
      'has-danger': _vm.hasError
    }
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label) + ": "), (_vm.required) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.hasError
    },
    attrs: {
      "type": "number",
      "id": _vm.name,
      "name": _vm.name,
      "required": _vm.required,
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "keyup": _vm.keyUpHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86ce1b5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/IntegerField.vue
// module id = 1741
// module chunks = 2